.MainContent {
    min-height: 770px;
    background: url('../../assets/images/main-bg.png') no-repeat top;
    background-size: contain;
    border: 1px solid transparent;
}
